export class ListCatalogTablesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<Table>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCatalogTablesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
